/**
 * Mapea `condVta` del cliente al valor del selector de forma de pago.
 * No define el catálogo: recibe la lista desde `constants/formasDePagoVenta.ts`
 * (o la que use cada pantalla).
 */
export function formaDePagoDesdeCondVta(
  formas: readonly string[],
  condVta: string | null | undefined,
  fallback = '',
): string {
  const raw = String(condVta ?? '').trim();
  if (!raw) return fallback;

  const norm = (s: string) => s.replace(/[\s.]/g, '').toUpperCase();
  const k = norm(raw);
  const byNorm = formas.find((fp) => norm(fp) === k);
  if (byNorm) return byNorm;

  return formas.find((fp) => fp.toUpperCase() === raw.toUpperCase()) ?? fallback;
}

export function formaDePagoDesdeCliente(
  cliente: { condVta?: string | null } | null | undefined,
  formas: readonly string[],
  fallback = '',
): string {
  if (!cliente) return fallback;
  const ext = cliente as { condVta?: string | null; condvta?: string | null; CondVta?: string | null };
  const raw = ext.condVta ?? ext.condvta ?? ext.CondVta ?? null;
  return formaDePagoDesdeCondVta(formas, raw, fallback);
}
